import type { GTParams, SDKCommonParams } from './types';
import { gtsp, sp } from './types';
import { serializeString } from './utils';

export const logEvent = async (commonParams: SDKCommonParams, params: GTParams) => {
    const baseurl = window.__GUMTREE_LOGEVENT_BASE_URL__ || location.origin;

    if (baseurl) {
        const url = `${baseurl}/buriedlog/buried-point/v1`;
        const webUrl = `${baseurl}/buriedlog/buried-point/web`;

        // Use sendBeacon to ensure tracking events are sent even during page unload
        // Safari interrupts fetch/axios requests during page navigation, sendBeacon prevents data loss
        if (navigator.sendBeacon) {
            try {
                // Use \u0001 separator
                const commonParamsString = serializeString(commonParams, sp);
                const paramsString = serializeString(params, sp);

                const urlWithParams = `${webUrl}?common_params=${encodeURIComponent(
                    commonParamsString
                )}&body=${encodeURIComponent(paramsString)}`;
                
                const success = navigator.sendBeacon(urlWithParams);

                if (!success) {
                    sendWithFetchKeepalive(url, commonParams, params);
                }
            } catch (error) {
                sendWithFetchKeepalive(url, commonParams, params);
                console.error('sendBeacon error:', error);
            }
        } else {
            sendWithFetchKeepalive(url, commonParams, params);
        }
    }
};

// Fallback to fetch keepalive if sendBeacon fails (e.g., data too large)
const sendWithFetchKeepalive = (
    url: string,
    commonParams: SDKCommonParams,
    params: GTParams
): void => {
    // Common params use gt0001 separator, body uses \u0001 separator
    const commonParamsHeader = serializeString(commonParams, gtsp);
    const paramsString = serializeString(params, sp);

    fetch(url, {
        method: 'POST',
        headers: {
            'common-param': commonParamsHeader,
            'Content-Type': 'text/plain',
        },
        body: paramsString,
        keepalive: true,
        credentials: 'include',
    }).catch((err) => console.error('Fetch keepalive failed:', err));
};
